import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_ENDPOINT}/api/meters-management`;

const createAuthHeaders = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const fetchMeters = async (token) => {
  const { data } = await axios.get(
    `${BASE_URL}/meters`,
    createAuthHeaders(token)
  );
  return data;
};

export const fetchMeter = async (token, meterId) => {
  const { data } = await axios.get(
    `${BASE_URL}/meters/${meterId}`,
    createAuthHeaders(token)
  );
  return data;
};

export const fetchMeterHistory = async (token, meterId) => {
  const { data } = await axios.get(
    `${BASE_URL}/meters/${meterId}/history`,
    createAuthHeaders(token)
  );
  return data;
};

export const fetchWells = async (token) => {
  const { data } = await axios.get(
    `${BASE_URL}/wells`,
    createAuthHeaders(token)
  );
  return data;
};

export const fetchMeterTypes = async (token) => {
  const { data } = await axios.get(
    `${BASE_URL}/meter-types`,
    createAuthHeaders(token)
  );
  return data;
};

export const fetchUnitNatives = async (token) => {
  const { data } = await axios.get(
    `${BASE_URL}/unit-natives`,
    createAuthHeaders(token)
  );
  return data;
};

export const fetchGalConversions = async (token) => {
  const { data } = await axios.get(
    `${BASE_URL}/gal-conversions`,
    createAuthHeaders(token)
  );
  return data;
};

export const createMeter = async ({ token, payload }) => {
  const { data } = await axios.post(
    `${BASE_URL}/meters`,
    payload,
    createAuthHeaders(token)
  );
  return data;
};

export const updateMeter = async ({ token, meterId, payload }) => {
  const { data } = await axios.put(
    `${BASE_URL}/meters/${meterId}`,
    payload,
    createAuthHeaders(token)
  );
  return data;
};

export const toggleRetiredMeter = async ({ token, meterId }) => {
  const { data } = await axios.put(
    `${BASE_URL}/meters/${meterId}/retire`,
    {},
    createAuthHeaders(token)
  );
  return data;
};

export const installMeter = async ({ token, meterId, payload }) => {
  const { data } = await axios.post(
    `${BASE_URL}/meters/${meterId}/install`,
    payload,
    createAuthHeaders(token)
  );
  return data;
};

export const removeMeter = async ({ token, meterId, payload }) => {
  const { data } = await axios.post(
    `${BASE_URL}/meters/${meterId}/remove`,
    payload,
    createAuthHeaders(token)
  );
  return data;
};

export const transferMeter = async ({ token, meterId, payload }) => {
  const { data } = await axios.post(
    `${BASE_URL}/meters/${meterId}/transfer`,
    payload,
    createAuthHeaders(token)
  );
  return data;
};
